module.exports = __webpack_public_path__ + "static/fabrica-slide2-c8aaa44fefd0ebaff9819957530b46ff.jpg";